exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.upload-document-wrapper[data-v-4331906e] {\n  background-color: #f3f6fa;\n  border: 2px dashed #eeeeee;\n  margin-right: 10px;\n  width: 200px;\n  height: 70px;\n}\n.upload-document-wrapper .dropzone[data-v-4331906e] {\n    background-color: unset !important;\n}\n.upload-document-wrapper .h-100[data-v-4331906e] {\n    height: 70px !important;\n}\n.upload-document-wrapper .upload-title[data-v-4331906e] {\n    color: #8e8e92;\n    font-weight: bold;\n    margin-left: 5px;\n    text-decoration: underline;\n    font-size: 13px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4331906e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/jobs/subcomponents/UploadDocument.vue
// module id = rLMo
// module chunks = 0